import { boot, i18n, useTranslation } from '@ad-lucy/translation';
import ADM_DE from './locales/de/adm-ui.json';
import ADM_EN from './locales/en/adm-ui.json';

const LOCALE = {
  DE: 'de',
  EN: 'en',
};
const i18nRegisterLocale = () => {
  i18n
    .addResourceBundle(LOCALE.EN, 'adm-ui', ADM_EN)
    .addResourceBundle(LOCALE.DE, 'adm-ui', ADM_DE);
};
type Options = Parameters<typeof useTranslation>[1];
type Translator = ReturnType<typeof useTranslation>['t'];

const useI18n = (options: Options = {}) => {
  const { t } = useTranslation('adm-ui', options);
  return { i18n, t };
};

interface i18nBootOptions {
  supportedLngs?: string;
}

const i18nBoot = ({
  supportedLngs = import.meta.env.VITE_SUPPORTED_LANGUAGES,
}: i18nBootOptions = {}) => {
  // init translation package
  return boot({
    supportedLngs,
  }).catch((error) => {
    console.error('Error booting translation package', error);
  });
};

export type { Translator };
export { i18nBoot, i18nRegisterLocale, useI18n };
